<template>
    <div>
        <ModalGlobal id="ModalRememberClose" v-if="$store.state.componentes.modalCloseSession"
            @close-modal="$store.dispatch('setModalCloseSession', false);">
            <template #dialogHeadImg>
                <img class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
                    :src="$S3AssetUrl('suf/home/photo-pass-logo.png')" alt="Grupo Xcaret | Foto"
                    title="Grupo Xcaret | Foto" />
            </template>

            <template #dialogHeading>{{ $t('Forms.imp') }}</template>

            <template #dialogDescription v-if="$store.state.isGuest">
                <span class="block text-justify" v-html="$t('Modals.login_description_logged_guest')"></span>
                <img class="mt-6"
                    :src="$S3AssetUrl('/suf/remember_close_your_session_'+$store.getters.getLanguage+'.jpg')"
                    alt="Grupo Xcaret | Ayuda de Sesión" title="Grupo Xcaret | Ayuda de Sesión">
            </template>
            <template #dialogDescription v-else>
                <span class="block text-justify" v-html="$t('Modals.login_description_logged')"></span>
                <img class="mt-6"
                    :src="$S3AssetUrl('/suf/remember_close_your_session_authenticate_' + $store.getters.getLanguage + '.jpg')"
                    alt="Grupo Xcaret | Ayuda de Sesión" title="Grupo Xcaret | Ayuda de Sesión">
            </template>
        </ModalGlobal>
    </div>
</template>

<script>
export default {
    props: [],
    mixins: [],
    components: {},
    data: () => ({}),
    computed: {},
    watch: {},
    methods: {},
    created() {},
    mounted() {},
};
</script>

